import { pushAnalyticsObjToDataLayer } from "@/utils/helper"

export const addAnalyticsObjForAccordion = (
  analyticTitleData,
  productInfoData
) => {
  const eventInfo = analyticTitleData ? JSON.parse(analyticTitleData) : {}
  const productInfo = productInfoData ? JSON.parse(productInfoData) : {}
  pushAnalyticsObjToDataLayer(eventInfo, "cmp:click", {}, productInfo)
}
